export enum PendoEventNames {
    REINTEGRATION_EVENT = 'leadgen_social_media_posting_reintegration_event',
  }